import { render, staticRenderFns } from "./WiFi.vue?vue&type=template&id=edbc63da&"
import script from "./WiFi.vue?vue&type=script&lang=js&"
export * from "./WiFi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports